<template>
    <div class="bodyLogin">
        <div class="d-flex flex-column align-items-center login__container" :class="show_messages ? 'justify-content-end' : 'justify-content-center'" :style="show_messages ? 'padding-bottom: 10px;' : ''">
            <div class="w-100 login mx-auto">

                <img  src="assets/img/logo.png" class="d-block mx-auto pt-md-0 login__logo" alt="logo"/>

                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <form  @submit.prevent="firstLogin()" class="login__form">

                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                            <div class="login__input first">
                                <img src="assets/img/us.png" alt="Icon us" class="login__input__icon">
                                <label for="email" class="login__input__label">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    :class="errors.length ? 'invalid': 'validate'"
                                    v-model="email"
                                    class="login__input__field"
                                />
                                <span v-if="errors.length" class="red-text" data-error="wrong" data-success="right" v-html="errors[0]"/>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                            <div class="login__input">
                                <img src="assets/img/pass.png" alt="Icon password" class="login__input__icon"/>

                                <label for="password" class="login__input__label">Password</label>

                                <input
                                    id="password"
                                    :type="input_type"
                                    :class="errors.length ? 'invalid': 'validate'"
                                    v-model="password"
                                    class="login__input__field"
                                />

                                <img id="eye-hide" src="assets/img/svg/eye-hide.svg" alt="" class="login__input__eye toggle-password" @click="show_password()"/>

                                <span v-if="errors.length" class="red-text" data-error="wrong" data-success="right" v-html="errors[0]"/>
                            </div>
                        </ValidationProvider>

                        <a href="#" @click="showResetPasswordModal()" class="d-inline-block forgot-password">Forgot your password?</a>

                        <button :class="`button--3 w-100 login__submit`" :disabled="invalid" v-html="'Login'"/>

                    </form>
                </ValidationObserver>
            </div>
            
            <div
                v-show="show_messages"
                class="w-100 login mx-auto mt-4"
                style="max-width: 700px; padding-top: 5px; padding-bottom: 5px;"
            >
                <MessageComponent ref="loginMessages" rest_api="auth/messages/web_login" class="mt-3" @showMessages="setShowMessages($event)"/>
            </div>
        </div>

        
        <FacilitySelection 
            :title="title"
            :associates="associates"
            :corporations="corporations"
            :corporation_id="corporation_id"
            :user="user"
            @login="secondLogin($event)"
        />

        <ResetPasswordModal />

        <WaitingModal/>
        
    </div>
</template>

<script>

import WaitingModal     from    '@/components/WaitingModal'
import FacilitySelection from './FacilitySelection'
import ResetPasswordModal from './ResetPasswordModal'
import moment from 'moment'
import MessageComponent from '../HomeComponent/MessageComponent.vue'
export default {
    name: 'Login',

    components: {
        WaitingModal,
        FacilitySelection,
        ResetPasswordModal,
        MessageComponent
    },

    data() {
        return {
            email:      '',
            password:   '',
            input_type: 'password',
            title: '',
            associates: [],
            corporations: [],
            corporation_id: '',
            user: {},
            show_messages: false
        }
    },
    methods: {
        setShowMessages(value)
        {
            this.show_messages = value
        },
        showResetPasswordModal()
        {
            window.$('#static-reset-password').modal('show')
        },
        async firstLogin()
        {
            this.loader(true)
            const response = await this.post('auth/first_authenticate', { ...this.$data }, {}, false);
            this.loader()

            if(response.status) 
            {
                this.associates = response.data.associates
                this.corporations = response.data.corporations
                this.user = response.data.user
                this.corporation_id = this.user.corporation_id

                if(this.corporation_id)
                {
                    if(this.associates && this.associates.length == 1)
                    {
                        await this.secondLogin({associate: this.associates[0]})
                    }   
                }

                this.title = `Welcome again ${this.user.name}`
                window.$('#static-facility-selection').modal('show')
            }
            else
            {
                this.error_handling(response, false)
            }
        },

        async secondLogin(event)
        {
            const response = await this.postingByPost('auth/login', { ...this.$data, associate: event.associate, old_web_site: true }, 'static-facility-selection', false, false);

            if(response.number_status == 301)
            {
                window.location.href = `https://mydigitalsolutions.dev/#/auth/login?redirected=true&email=${this.email}`
            }
            else if(response.status) 
            {
                const auth_info = response.data;
                localStorage.setItem('access_token', auth_info.access_token)
                localStorage.setItem('refresh_token', auth_info.refresh_token)
                localStorage.setItem('expire_session_seconds', auth_info.expires_in)
                localStorage.setItem('expires_in', moment().add(auth_info.expires_in, 'seconds').format())
                await this.createAxiosInstance(auth_info.access_token)
                await this.getAssociate()
            }
            else
            {
                this.error_handling(response, false)
            }

            return true;

        },

        async getAssociate()
        {
            console.log('getting associate');
            this.invoke_loader('post')
            const response = await this.get('auth/associate');
            this.revoke_loader('post')

            if(response.status) 
            {
                 
                localStorage.setItem('user', JSON.stringify(response.data.user) )
                localStorage.setItem('routes', JSON.stringify(response.data.routes) )
                window.location.href = '/'

            
            }
            else
            {
                this.error_handling(response, false)
            }
        },

        show_password()
        {
            this.input_type = this.input_type === 'password' ? 'text' : 'password'
        },
    }
}

</script>

<style scoped>
    
</style>